import script from "./fileAction.vue?vue&type=script&setup=true&lang=js"
export * from "./fileAction.vue?vue&type=script&setup=true&lang=js"

import "./fileAction.vue?vue&type=style&index=0&id=14d2a417&lang=css"

const __exports__ = script;

export default __exports__